export default Object.freeze({
    ALERT_TYPE_ERROR: 'error',
    ALERT_TYPE_SUCCESS: 'success',
    ALERT_TYPE_INFO: 'info',
    MAX_NO_OF_QUESTIONS: 5,
    MODULE_BANNER: 'banner',
    MODULE_DASHBOARD: 'dashboard',
    MODULE_REPORT: 'report',
    MODULE_SWIFT_CHECK_IN: 'swiftCheckIn',
    MODULE_SUPPORT: 'support',
    MODULE_USER_PROFILE: 'userProfile',
    SUB_MODULE_ADVANCED_SCHEDULING: 'advancedScheduling',
});
